import useFetch from "@/hook/useFetch/useFetch";
import CustomButton from "../custom-button/custom-button";
import SparksOverlay from "../sparks-overlay/sparks-overlay";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { getCampaignNextMission } from "@/services/campaign/campaign";

interface NextMissionButtonProps {
  missionId: string | number;
  campaignId: string | number;
}

const MESSAGE_BUTTON: Record<string, string> = {
  "/mission": "Siguiente misión",
  "/campaign": "Siguiente campaña",
  "/home": "Volver al inicio",
};

const NextMissionButton: React.FC<NextMissionButtonProps> = ({ missionId, campaignId }) => {
  const navigate = useNavigate();
  const existParamsProps = Boolean(missionId && campaignId);
  const { data, loading } = useFetch(getCampaignNextMission, { mission_id: missionId, campaign_id: campaignId }, { autoFetch: existParamsProps });
  const { campaign_id = '', mission_id = '' } = data;

  const urlCampaignAndMission = mission_id && campaign_id ? `/mission/${campaign_id}/${mission_id}` : null;
  const urlCampaign = campaign_id ? `/campaign/${campaign_id}` : null;
  const urlEnd = urlCampaignAndMission ?? urlCampaign ?? "/home";

  const textButton =
    Object.entries(MESSAGE_BUTTON).find(([key]) => urlEnd?.startsWith(key))?.[1] ?? null;

  const handleGo = useCallback(() => {
    if (urlEnd) {
      navigate(urlEnd);
      window.location.reload();
    }
  }, [urlEnd, navigate]);

  if (loading || !textButton) {
    return null;
  }

  return (
    <center>
      <CustomButton
        data-testid="button-next-mission"
        type="primary"
        onClick={handleGo}
      >
        {textButton}
        <SparksOverlay />
      </CustomButton>
    </center>
  );
};

export default NextMissionButton;
